import {registerDescr} from './ds'
import { Default } from './descriptors/default';
import { Admin, DealAdmin } from './descriptors/admin';
import { TestTable, TestTable2 } from './descriptors/testTable';
import { EIDeal, EICreateDelivery, CliInfo, moveGuide, CreateDeliveryEI, EIProduct, packageSelect, tagSelect, consumeSelect, packageSelectOnlyCheck, otherServiceDS,ClientSettings, EIDealFBS, unity_deal, ReturnsDealsAdmin, EIDealNoStatus, packageSelectNoEdit, otherServiceDSNoEdit, consumeSelectNoEdit} from './descriptors/elementinfods';
import { AddWorker, EditWorker, Roles } from './descriptors/worker';
import { TableDs } from './descriptors/calcTable';
import { AddressDs, GoodsDs, MovingDealsDs, MyClientsDs, NewClientsDs, ProductsShipmentDs, ProductsStorageDs } from './descriptors/addressableStorage';
import { Requisites } from './descriptors/requisites';
import { AddFinance, Finance } from './descriptors/finance';
import { AddClientWorker, Client, ClientsRoles, cliWorkerList, DealClient, DealClientConsum, EditClientWorker, settingsClient } from './descriptors/client';
import { AddPdf, AddProducts, ChooseProducts, AddTech, CreateDelivery, ViewPdf, ClientProducts, ClientBarcodes, ProductTotalCount, ClientProductsStorage,ClientProductsStorageCustom, ProductsForNewDeal, MyConsumables, CreateDeliveryConsumes, viewIMG, ClientProductsAdmin, ProductsForNewDealReturns, ViewPdfUsed, ClientProductsModern } from './descriptors/createDelivery';
import { hanbookPlaceList } from './descriptors/handBook'
import { Manager } from './descriptors/manager';
import { BindProducts, BindProductsClient, BindProductsSelected, CopyProductsSelected, DealPay, DealPayClient, DealTable, NotBindProducts, DealTableForClient, DealTableConsume, multiWayDelivery, DealTableForClientConsum, fbsAdmin, fbsAdminOpen, ReturnsTable, ClientsDefects, ClientsReturns, multiWayDeliveryBC, BindProductsBlocked, ReturnsTableModern, BindProductsSelectedFloat, fbsAdminWB, fbsAdminOZON, DealTableFBSWB, fbsAdminOpenWB } from './descriptors/deal';

// инициализация дескрипторов
export function init() {
    registerDescr(Default);
    registerDescr(Admin);
    registerDescr(Manager);
    registerDescr(Client);
    registerDescr(cliWorkerList);
    registerDescr(DealClient);
    registerDescr(DealClientConsum);
    registerDescr(DealAdmin);
    registerDescr(TestTable);
    registerDescr(DealTable);   
    registerDescr(DealTableForClient) 
    registerDescr(DealTableForClientConsum) 
    registerDescr(DealTableFBSWB) 
    registerDescr(fbsAdmin) 
    registerDescr(fbsAdminWB) 
    registerDescr(fbsAdminOZON) 
    registerDescr(TestTable2);
    registerDescr(CreateDelivery);
    registerDescr(CreateDeliveryConsumes);
    registerDescr(CreateDeliveryEI);
    registerDescr(AddProducts);
    registerDescr(ChooseProducts);
    registerDescr(BindProducts);
    registerDescr(BindProductsBlocked);
    registerDescr(BindProductsClient);
    registerDescr(NotBindProducts);
    registerDescr(multiWayDelivery);
    registerDescr(BindProductsSelected);
    registerDescr(BindProductsSelectedFloat);
    registerDescr(CopyProductsSelected);
    registerDescr(ProductsForNewDeal);
    registerDescr(ProductsForNewDealReturns);
    registerDescr(ClientProducts);
    registerDescr(ClientProductsModern);
    registerDescr(ClientProductsAdmin);
    registerDescr(ClientBarcodes);
    registerDescr(ClientProductsStorage);
    registerDescr(ClientProductsStorageCustom);
    registerDescr(ProductTotalCount);
    registerDescr(AddTech);
    registerDescr(AddPdf);
    registerDescr(ViewPdf);
    registerDescr(ViewPdfUsed);
    registerDescr(viewIMG);
    registerDescr(AddWorker);
    registerDescr(EditWorker);
    registerDescr(AddClientWorker);
    registerDescr(EditClientWorker);
    registerDescr(Roles);
    registerDescr(ClientsRoles);
    registerDescr(settingsClient);
    registerDescr(ClientSettings);
    
    registerDescr(EIDeal);
    registerDescr(EIDealNoStatus);
    registerDescr(EIDealFBS);
    registerDescr(EIProduct);
    registerDescr(EICreateDelivery);
    registerDescr(moveGuide);
    registerDescr(CliInfo);
    registerDescr(unity_deal);
    registerDescr(packageSelect);
    registerDescr(packageSelectNoEdit);
    registerDescr(packageSelectOnlyCheck);
    registerDescr(otherServiceDS);
    registerDescr(otherServiceDSNoEdit);
    registerDescr(consumeSelect)
    registerDescr(consumeSelectNoEdit)
    registerDescr(ReturnsTable);
    registerDescr(ReturnsTableModern);
    registerDescr(ClientsDefects);
    registerDescr(ClientsReturns);

    registerDescr(tagSelect);
    
    registerDescr(TableDs);
    registerDescr(AddressDs);
    registerDescr(GoodsDs);
    registerDescr(MovingDealsDs);
    registerDescr(ProductsStorageDs);
    registerDescr(ProductsShipmentDs);
    registerDescr(NewClientsDs);
    registerDescr(MyClientsDs);
    registerDescr(Requisites);
    registerDescr(Finance);
    registerDescr(AddFinance);
    registerDescr(hanbookPlaceList);
    registerDescr(DealPay);
    registerDescr(DealPayClient);
    registerDescr(MyConsumables);
    registerDescr(DealTableConsume)
    registerDescr(fbsAdminOpen)
    registerDescr(fbsAdminOpenWB)
    registerDescr(ReturnsDealsAdmin)
    registerDescr(multiWayDeliveryBC)
    
}